import { useRef } from 'react'
import { gsap, prefersReduced } from '../../lib/gsap.js'
import useIso from './useIso.js'

// One-shot fade+rise of a container's children. Plays the first time the targets
// exist (guards against Firestore streaming rows in after mount); never replays.
export default function useEnterStagger(ref, { dep, selector = ':scope > *' } = {}) {
  const played = useRef(false)
  useIso(() => {
    if (played.current) return
    const el = ref.current
    if (!el) return
    const targets = el.querySelectorAll(selector)
    if (!targets.length) return
    played.current = true
    if (prefersReduced()) return
    // clearProps: a leftover identity transform would otherwise make each target
    // the containing block for position:fixed descendants — offsetting (and
    // overflow-clipping) the board drag's lifted card.
    gsap.from(targets, { opacity: 0, y: 8, duration: 0.35, stagger: 0.04, ease: 'power2.out', clearProps: 'opacity,transform' })
  }, [dep])
}
